import DataAccess from './constants';
import API from './API'

const path = 'customers'

export const getmember = (params) => {
    let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);
    return api.getData(path + params);
}

export const postmember = (member) => {
    let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);
    return api.postData(path, member);
}

export const putmember = (member) => {
    let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);
    return api.putData(path, member);
}